export function calcDistance(x: number, y: number): number {
  return Math.floor(Math.sqrt((x * x) + (y * y)));
}